<template>
  <section class="device_adresses">
    <div class="response_table">
      <table>
        <thead>
          <tr>
            <th scope="col"> {{ translate("config.addr_name") }} </th>
            <th scope="col"> {{ translate("config.section_name") }} </th>
            <th scope="col"> {{ translate("config.ip") }} </th>
            <th scope="col"> {{ translate("config.ports") }} </th>
            <th scope="col"> {{ translate("config.ts_create") }} </th>
            <th v-if="p_god" class="w30" scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <router-link
              v-for="(address, address_key) in device_addresses"
              :key="address_key"
              :to="'/ip_address/' + address.addr_id"
              class="link"
          >
            <tr class="pointer">
              <td :data-label='translate("config.addr_name")' >
                {{ address.name }}
              </td>
              <td :data-label='translate("config.section_name")' >
                {{ address.section_name }}
              </td>
              <td :data-label='translate("config.ip")' >
                {{ address.ip }}
                <span class="mdi mdi-content-copy" @click.prevent.stop="copy_ip(address.ip)" />
              </td>
              <td :data-label='translate("config.ports")' >
                {{ address.ports }}
              </td>
              <td :data-label='translate("config.ts_create")' >
                {{ get_date(address.ts_create) }}
              </td>
              <td v-if="p_god" class="w30">
                <span class="mdi mdi-cog pointer" @click.prevent.stop="show_modal(address)" />
              </td>
            </tr>
          </router-link>
        </tbody>
      </table>
    </div>
  </section>
</template>

<script>
import EditDeviceAddresses from "./Edit/Index.vue";

export default {
  name: 'Device_adresses',
  props: ['device_addresses'],

  computed:{
    p_god(){
      return this.$store.getters.getPermissions.permissionGod === true
    }
  },
  methods: {
    copy_ip(string){
      this.copy_to_clipboard(string);
      this.global_notify("info", this.translate("clipboard.value_save_buffer"));
    },
    show_modal(address){
      let t = this.$createElement(EditDeviceAddresses, {
        props: {
          address
        },
        on: {
          close: () => {
            this.$modal.hide('dynamic-modal')
          },
          update: () => {
            this.$emit("update")
            this.$modal.hide('dynamic-modal')
          }
        }
      })
      let temp = { render () { return t } }
      this.$modal.show(temp, {}, {height: 'auto', adaptive: true, clickToClose: true, scrollable: true, name: 'dynamic-modal'})
    },
  }
}
</script>

<style lang="scss" scoped>
  .device_adresses{
    .response_table{
      padding: 5px 0;
      tbody tr:hover{
        background-color: #eee;
      }
    }
  }
</style>
